import Dashboard from "./Pages/Dashboard";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Login from "./Pages/Login";
import NotFound from "./Pages/NotFound";
import { useEffect, useState, useRef } from "react";
import ProtectedRoute from "./Components/ProtectedRoutes";
import PublicRoute from "./Components/PublicRoute";
import Users from "./Pages/Users";
import UserDetails from "./Pages/UserDetails";
import Logo from "./Images/Logo.png";
import search from './Images/search-line.svg';
import { GoCreditCard } from "react-icons/go";
import { RiHome6Line } from "react-icons/ri";
import { PiUsersThree } from "react-icons/pi";
import Wedding from "./Pages/Wedding";
import AdminUser from "./Pages/AdminUser";
import Themes from "./Pages/Themes";

function App() {
  const [dashboardView, setDashboardView] = useState(() => {
    const view = localStorage.getItem('dashboardView') || 'overview'

    return view
  });
  const location = useLocation()
  const navigate = useNavigate();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const timestamp = localStorage.getItem("tokenTimestamp");
    const now = Date.now();
    const TWO_DAYS = 2 * 24 * 60 * 60 * 1000;
    if (timestamp && now - Number(timestamp) > TWO_DAYS) {
      localStorage.clear();
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  const logout = () => {
    localStorage.clear()
    window.location.reload()
  }

  const hide = location.pathname.includes('/login') || location.pathname.includes('/404')

  return (
    <div className="min-h-screen bg-[#FCFCFC] sm:px-10 px-5">

      {!hide && (
        <div className="pt-4 bg-white border-b-[1.5px] border-[#E9EAEC] space-y-6">
          <div className="flex flex-row items-center justify-between gap-3 max-w-[1100px] mx-auto">
           <div className="flex items-center gap-3">
  {/* Increased height from 42px to 56px, aspect ratio handles the width */}
  <img src={Logo} className="h-[56px] w-auto object-contain" alt="Logo" />
  
  {/* Added span text with styling */}
  <span className="text-xl font-bold tracking-wide text-gray-800 capitalize">
    philomena admin
  </span>
</div>
            <div className="relative hidden sh:block">
              <input
                className='px-[14px] pl-[40px] py-[8px] w-[320px] rounded-xl border bg-transparent shadow-md shadow-[#14151A0D] border-[#D2D0D6]'
                type="text"
                name="search"
                placeholder='Search users...'
              />
              <img src={search} className="absolute w-5 h-5 -translate-y-1/2 top-1/2 left-2 opacity-" alt="" />
            </div>
            <div className="relative" ref={dropdownRef}>
              <div
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="rounded-full w-14 h-14 flex items-center justify-center font-semibold border border-[#DEE0E3] shadow-md shadow-[#14151A0D] cursor-pointer"
              >
                OE
              </div>

              {/* Dropdown */}
              {dropdownOpen && (
                <div className="absolute right-0 z-50 w-32 mt-2 bg-white border rounded-lg shadow-lg">
                  <button
                    onClick={() => {
                      setModalOpen(true);
                      setDropdownOpen(false);
                    }}
                    className="w-full px-4 py-2 text-left rounded-lg hover:bg-gray-100"
                  >
                    Log Out
                  </button>
                </div>
              )}
            </div>

            {/* Modal */}
            {modalOpen && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white rounded-lg p-6 w-[300px]">
                  <div className="mb-4 text-center">
                    <h2 className="text-xl font-semibold text-gray-800">Logout</h2>
                    <p className="mt-1 text-gray-600">
                      Are you sure you want to logout?
                    </p>
                  </div>
                  <div className="flex justify-end gap-2">
                    <button
                      onClick={() => setModalOpen(false)}
                      className="px-4 py-2 border rounded-lg hover:bg-gray-100 border-black/40"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => {
                        setModalOpen(false);
                        logout()
                      }}
                      className="px-4 py-2 text-white bg-black rounded-lg"
                    >
                      Log Out
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="relative block sh:hidden">
            <input
              className='px-[14px] pl-[40px] py-[8px] w-full rounded-xl border bg-transparent shadow-md shadow-[#14151A0D] border-[#D2D0D6]'
              type="text"
              name="search"
              placeholder='Search users...'
            />
            <img src={search} className="absolute w-5 h-5 -translate-y-1/2 top-1/2 left-2 opacity-" alt="" />
          </div>

          <div className="max-w-[1100px] mx-auto overflow-x-auto no-scrollbar">
            <div className="flex items-center justify-start gap-5 whitespace-nowrap min-w-max">

              <div
                onClick={() => {
                  navigate('/')
                  setDashboardView('overview')
                  localStorage.setItem('dashboardView', 'overview')
                }}
                className={`flex items-center pb-3 ${dashboardView === 'overview'
                  ? 'border-[#62259A] font-medium text-[#62259A] border-b-2'
                  : 'text-[#0F132499]'
                  } p-2 py-1 cursor-pointer gap-2`}
              >
                <RiHome6Line className="text-lg sm:text-xl" />
                <p className="text-sm font-semibold sm:text-lg">Overview</p>
              </div>

              <div
                onClick={() => {
                  navigate('/')
                  setDashboardView('users')
                  localStorage.setItem('dashboardView', 'users')
                }}
                className={`flex items-center pb-3 ${dashboardView === 'users' || dashboardView === 'userDetails'
                  ? 'border-[#62259A] font-medium text-[#62259A] border-b-2'
                  : 'text-[#0F132499]'
                  } p-2 py-1 cursor-pointer gap-2`}
              >
                <PiUsersThree className="sm:text-lg" />
                <p className="text-sm font-semibold sm:text-lg">Users</p>
              </div>

              <div
                onClick={() => {
                  navigate('/')
                  setDashboardView('weddings')
                  localStorage.setItem('dashboardView', 'weddings')
                }}
                className={`flex items-center pb-3 ${dashboardView === 'weddings'
                  ? 'border-[#62259A] font-medium text-[#62259A] border-b-2'
                  : 'text-[#0F132499]'
                  } p-2 py-1 cursor-pointer gap-2`}
              >
                <GoCreditCard className="sm:text-lg" />
                <p className="text-sm font-semibold sm:text-lg">Weddings</p>
              </div>

              <div
                onClick={() => {
                  navigate('/')
                  setDashboardView('adminUsers')
                  localStorage.setItem('dashboardView', 'adminUsers')
                }}
                className={`flex items-center pb-3 ${dashboardView === 'adminUsers'
                  ? 'border-[#62259A] font-medium text-[#62259A] border-b-2'
                  : 'text-[#0F132499]'
                  } p-2 py-1 cursor-pointer gap-2`}
              >
                <i className="text-lg ri-user-6-line sm:text-xl"></i>
                <p className="text-sm font-semibold sm:text-lg">Admin Users</p>
              </div>

              <div
                onClick={() => {
                  navigate('/')
                  setDashboardView('themes')
                  localStorage.setItem('dashboardView', 'themes')
                }}
                className={`flex items-center pb-3 ${dashboardView === 'themes'
                  ? 'border-[#62259A] font-medium text-[#62259A] border-b-2'
                  : 'text-[#0F132499]'
                  } p-2 py-1 cursor-pointer gap-2`}
              >
                <i className="text-lg ri-user-6-line sm:text-xl"></i>
                <p className="text-sm font-semibold sm:text-lg">Themes</p>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* Main content */}
      <div className="max-w-[1100px] mx-auto">
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                {dashboardView === 'overview' ? (
                  <Dashboard setDashboardView={setDashboardView} />
                ) : dashboardView === 'users' ? (
                  <Users setDashboardView={setDashboardView} />
                ) : dashboardView === 'weddings' ? (
                  <Wedding />
                ) : dashboardView === 'adminUsers' ? (
                  <AdminUser />
                ) : dashboardView === 'themes' ? (
                  <Themes setDashboardView={setDashboardView} />
                ) : dashboardView === 'userDetails' ? (
                  <UserDetails setDashboardView={setDashboardView} />
                ) : (
                  <NotFound />
                )}
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/users/:id"
            element={
              <ProtectedRoute>
                <UserDetails />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route path="*" element={<Navigate to="/404" replace />} />

          <Route path="/404" element={<NotFound />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
